<div class="zones-tile">
    @switch (tile.type) {
        @case ('additionalContact') { <additional-contact [tile]="tile" /> }
        @case ('alarm') { <zones-alarm-tile [tile]="tile" /> }
        @case (1) { <temperature-sensor [tile]="tile" /> }
        @case (11) { <relay [tile]="tile" /> }
        @case (24) { <built-in-valve [tile]="tile" /> }
        @case (25) { <simple-valve [tile]="tile" /> }
        @case (100) { <dhw-for-zones [tile]="tile" /> }
        @case (250) { <dhw-on-off [tile]="tile" /> }
        @case (251) { <dhw-with-events [tile]="tile" /> }
        @case (252) { <open-therm [tile]="tile" /> }
    }
</div>
